import { Component, OnInit, Optional, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { DataService } from 'src/app/providers/data.service';
import { ExamService } from 'src/app/providers/exam/exam.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { finalize, map } from 'rxjs/operators';
import { ClassService } from '../../providers/class/class.service';

@Component({
  selector: 'app-exam-modal',
  templateUrl: './exam-modal.component.html',
  styleUrls: ['./exam-modal.component.scss'],
  providers: [DataService]
})
export class ExamModalComponent implements OnInit {
  examForm: FormGroup;

  public dataClassList$: Observable<[]>;
  public dataExamTypeList$: Observable<[]>;

  constructor(
    public fb: FormBuilder,
    public dialogRef: MatDialogRef<ExamModalComponent>,
    public dataService: DataService,
    private examService: ExamService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    console.log(data);
      if (!this.data.id) {
        this.createForm();
      } else {
        this.editForm();
      }
    }

  ngOnInit(): void {
    //class list
    this.dataClassList$ = this.dataService.ClassList;
    this.dataService.getClassData().subscribe();

    //subject list
    this.dataExamTypeList$ = this.dataService.ExamTypeList;
    this.dataService.getExamTypeData().subscribe();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  createForm() {
    this.examForm = new FormGroup({
      Class_SysRef: new FormControl(),
      ExamType_SysRef: new FormControl(),
      description: new FormControl(),
      examDate: new FormControl(),
      passMark: new FormControl(),
      questionAmount: new FormControl(),
    });

    this.examForm = this.fb.group({
      Class_SysRef: ['', [Validators.required]],
      ExamType_SysRef: ['', [Validators.required]],
      description: ['', [Validators.required]],
      examDate: ['', [Validators.required]],
      passMark: [0.0,],
      questionAmount: [0,[Validators.required]]
    })
  }
  editForm() {
    this.examForm = new FormGroup({
      Class_SysRef: new FormControl(),
      ExamType_SysRef: new FormControl(),
      description: new FormControl(),
      examDate: new FormControl(),
      passMark: new FormControl(),
      questionAmount: new FormControl()
    });

    //console.log(this.data);

    this.examForm = this.fb.group({
      Class_SysRef: [this.data.class_sysref, [Validators.required]],
      ExamType_SysRef: [this.data.examType_SysRef, [Validators.required]],
      description: [this.data.description, [Validators.required]],
      examDate: [new Date(this.data.examDate).toISOString().substring(0, 10), [Validators.required]],
      passMark: [this.data.passMark],
      questionAmount: [this.data.questionAmount, [Validators.required]]
    })
  }

  addExam(){
    if (!this.data.id) {
      console.log(this.examForm.value);
      this.examService.addExam(this.examForm.value)
          .pipe(map(
          data => { console.log(data); return data },
          err => { console.log(err); return err }
          ),
            finalize(() => { this.dialogRef.close() })
          )
          .subscribe(
            data=>{
              return data;
         },
            err=>{alert("Invalid data");console.log(err)}
         );
    } else {
      console.log(this.examForm.value);
      console.log("data", this.data.passRate);
      this.examService.editExam(this.data.id, this.examForm.value)
        .pipe(map(
          data => { return data },
          err => { console.log(err); return err }
        ),
          finalize(() => {this.dialogRef.close()})
        )
        .subscribe(
          data => {
            return data;
          },
          err => { alert("Invalid data"); console.log(err) }
        );
    }
  }

  
}
